import { render, staticRenderFns } from "./cis-keywords.vue?vue&type=template&id=dc3496c6"
import script from "./cis-keywords.vue?vue&type=script&lang=js"
export * from "./cis-keywords.vue?vue&type=script&lang=js"
import style0 from "./cis-keywords.vue?vue&type=style&index=0&id=dc3496c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports